import { Component, inject } from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {PRE_LOGIN_PATH} from '../../app.component';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    standalone: false
})
export class LoginPageComponent {
    private msalService = inject(MsalService);


    async login() {
        try {
            await this.msalService.loginPopup().pipe(take(1)).toPromise()

            const previousUrl = sessionStorage.getItem(PRE_LOGIN_PATH)
            if (previousUrl) {
                setTimeout(() => {window.location.href = previousUrl;}, 500)
            }
        } catch (e) {
            console.error('login failed', e);
        }
    }
}
